import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import { SectionPostRaceCardsGroup, Text } from 'components'
import { translate } from 'react-i18next'
import PHASE from 'utils/constants/phases'
import ITEM from 'utils/constants/items'
import DATA_SELECTORS from 'data/selectors'
import { priceFormatted } from 'utils/string'
import { Phase } from '../Phase'
import './PostRace.css'

@pageData({ title: 'PostRace' })
@connect(
    state => ({
        phase: state.phaseInfo.phase,
        credits: state.phase.credits,
        selection: state.phase.selection,
        postRaceData: state.phaseInfo.data,
        isAMToolActive: state.phase.isAMToolActive,
        curvesParams: state.phaseInfo.performanceOverDeteriorationCurveParams,
        currentSelection: state.phaseInfo.currentSelection
    }),
    {
        setCredits: PhaseActions.setCredits,
        updateSelection: PhaseActions.updatePostRaceSelection
    }
)
@translate()
export class PostRace extends PureComponent {
    state = {
        selectedSelectorId: null
    }

    componentWillMount() {
        this.selectors = DATA_SELECTORS[PHASE.POST_RACE]
        this.refreshPhaseData(this.props)
    }
    componentWillUpdate(nextProps) {
        if (nextProps.phase === PHASE.POST_RACE) {
            if (nextProps.postRaceData !== this.props.postRaceData) {
                this.refreshPhaseData(nextProps)
            }
        }
    }

    setPhaseRef = ref => {
        this.phaseRef = ref
    }

    refreshPhaseData = props => {
        const { phase, postRaceData } = props
        if (phase === PHASE.POST_RACE) {
            this.cardsData = this.selectors.map(selector => {
                const data = postRaceData[selector.id]
                let bullets = selector.bullets
                if (selector.id === ITEM.POST_RACE_WHEELS) {
                    bullets = bullets.map((b, i) => {
                        if (i === 0) return `${b}: ${data.changesPlanned}`
                        if (i === 1) return `${b}: ${data.actualPlanned}`
                        if (i === 2) return `${b}: ${priceFormatted(data.extraPlannedCost)}`
                        if (i === 3) return `${b}: ${priceFormatted(data.extraActualCost)}`
                        return ''
                    })
                }
                return {
                    ...selector,
                    groupId: selector.id,
                    type: selector.type,
                    deterioration: data.deterioration,
                    bullets,
                    options: (data.options || []).map(option => ({ ...option, typeId: option.id }))
                }
            })
        }
    }

    handleSetOption = ({ error, groupId, typeId, deltaPrice }) => {
        const { credits, setCredits, updateSelection } = this.props
        // console.log(`selectOption: ${groupId} - ${typeId}`)
        if (error) {
            this.phaseRef.showModalErrorInfo(error)
        } else {
            setCredits(credits + deltaPrice)
            updateSelection(groupId, typeId)
        }
    }

    render() {
        const { phase, credits, selection, isAMToolActive, curvesParams, t } = this.props
        return phase === PHASE.POST_RACE && (
            <Phase className="PostRace" phaseRef={this.setPhaseRef} showEndPhaseBtn>
                <section className="PostRaceIntro flex row-left-bottom">
                    <Text className="PostRaceIntro-Wheels" dangerouslySetInnerHTML={{ __html: t('game.POST_RACE.intro.wheels') }} />
                    <Text className="PostRaceIntro-Rest" dangerouslySetInnerHTML={{ __html: t('game.POST_RACE.intro.rest') }} />
                </section>
                <SectionPostRaceCardsGroup
                    cards={this.cardsData}
                    availableCredits={credits}
                    selection={selection}
                    onSetOption={this.handleSetOption}
                    isAMToolActive={isAMToolActive}
                    curvesParams={curvesParams}
                />
            </Phase>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/PostRace/PostRace.js